import { render, staticRenderFns } from "./FormQuestionRating5Type.vue?vue&type=template&id=7d537d98"
import script from "./FormQuestionRating5Type.vue?vue&type=script&lang=js"
export * from "./FormQuestionRating5Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports